import { Amplify, type ResourcesConfig } from 'aws-amplify'
import { resolveEnvironmentName } from './environment'

const BRWFM_CALLBACK_PATH = '/wfm-client-signup/importData'

const userPoolId = import.meta.env['VITE_AMPLIFY_USER_POOL_ID'] as string | undefined
const userPoolWebClientId = import.meta.env['VITE_AMPLIFY_USER_POOL_WEB_CLIENT_ID'] as string | undefined
const identityPoolId = import.meta.env['VITE_AMPLIFY_IDENTITY_POOL_ID'] as string | undefined
const oauthDomain = import.meta.env['VITE_AMPLIFY_OAUTH_DOMAIN'] as string | undefined

function getDefaultHostedRedirect(): string {
  const envName = resolveEnvironmentName()
  if (envName === 'production' || envName === 'prod') return 'https://app.dashboardinsights.com/login/'
  if (envName === 'portal') return 'https://portal.dashboardinsights.com/login/'
  if (envName === 'staging') return 'https://staging.dashboardinsights.com/login/'
  return 'https://dev.dashboardinsights.com/login/'
}

const redirectSignIn = getDefaultHostedRedirect()
const redirectSignOut = getDefaultHostedRedirect()

const amplifyConfigured = !!(userPoolId && userPoolWebClientId && oauthDomain)

export function isAmplifyConfigured(): boolean {
  return amplifyConfigured
}

export function shouldSkipAmplifyForCurrentRoute(): boolean {
  if (typeof window === 'undefined') return false
  return window.location.pathname === BRWFM_CALLBACK_PATH
}

export function configureAmplify(): void {
  if (shouldSkipAmplifyForCurrentRoute()) return
  if (!userPoolId || !userPoolWebClientId || !oauthDomain) return

  const oauthConfig = {
    domain: oauthDomain,
    scopes: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: [redirectSignIn],
    redirectSignOut: [redirectSignOut],
    responseType: 'code' as const,
  }

  const awsmobile: ResourcesConfig = identityPoolId
    ? {
        Auth: {
          Cognito: {
            userPoolId,
            userPoolClientId: userPoolWebClientId,
            identityPoolId,
            loginWith: { oauth: oauthConfig },
          },
        },
      }
    : {
        Auth: {
          Cognito: {
            userPoolId,
            userPoolClientId: userPoolWebClientId,
            loginWith: { oauth: oauthConfig },
          },
        },
      }
  Amplify.configure(awsmobile)
}
